import React from 'react';

import Modal from 'components/new_ui/Modal/Modal';
import useAssessments from 'components/Common/Managers/Hooks/useAssessments';
import { useParams, useNavigate } from 'react-router-dom';
import Form from './Form';
import Table from './Table';

export default function Index() {
  const { memberId } = useParams();

  const { assessments, refresh } = useAssessments({ memberId });

  const navigate = useNavigate();

  const handleClose = () => {
    navigate(-1);
  };

  return (
    <Modal onHide={handleClose} show size="lg" header={<h2 className="ms-3">Assessments</h2>}>
      <Form refresh={refresh} />
      <Table assessments={assessments} refresh={refresh} />
    </Modal>
  );
}
